import { UiMessageBubbleStoreContext } from "./_sotre/UiMessageBubbleStore";
import { cn } from "@deputy-ai/common";
import { useAtomValues } from "@deputy-ai/common/jotai";
import { Tooltip } from "@deputy-ai/ui/tooltip/Tooltip";
import { LuCircle, LuCircleCheck } from "react-icons/lu";

export function UiMessageDeliveredStatus() {
  const { propsAtoms } = UiMessageBubbleStoreContext.useStore();
  const { isRead, isDelivered } = useAtomValues(propsAtoms);

  const key = isRead ? "read" : isDelivered ? "delivered" : null;

  if (!key) {
    return " ";
  }

  const { tooltip, Icon, color } = {
    read: {
      tooltip: "Read",
      Icon: LuCircleCheck,
      color: "text-green-600",
    },
    delivered: {
      tooltip: "Delivered",
      Icon: LuCircle,
      color: "text-gray-500",
    },
  }[key];

  return (
    <Tooltip content={<span className="text-xs">{tooltip}</span>}>
      <Icon
        className={cn(
          "absolute bottom-0.5 left-9 h-3 w-3 rounded-full bg-white",
          color
        )}
      />
    </Tooltip>
  );
}
